/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input} from '@angular/core';
import * as _ from 'lodash';
import template from './report-history.component.html';
import {ObjectTypeFinder} from '../common/constants/object-type';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';
import {ReportExecutionApiService} from './report-execution-api.service';

@Component({
  standalone: false,
  selector: 'adn-report-history',
  template
})
export class ReportHistoryComponent {
  @Input() reportExecutions: any[] = [];
  @Input() size: string;
  @Input() hideEmptyMessage: string;

  resolved = false;
  collapseExecutions = true;
  private _objType: string;
  private _objId: string;

  constructor(private readonly reportExecutionApi: ReportExecutionApiService,
              private readonly cdr: ChangeDetectorRef) {
  }

  @Input()
  set objType(value: string) {
    this._objType = value;
    this.updateReportExecutions();
  }

  get objType(): string {
    return this._objType;
  }

  @Input()
  set objId(value: string) {
    this._objId = value;
    this.updateReportExecutions();
  }

  get objId(): string {
    return this._objId;
  }

  get sortedExecutions(): any[] {
    return _.orderBy(this.reportExecutions, ['executionStartTime'], ['desc']);
  }

  private setReportExecutions(reportExecutions: any[], resolved = true): void {
    this.reportExecutions = reportExecutions || [];
    this.resolved = resolved;
  }

  private updateReportExecutions(): void {
    const apiParam = _.get(ObjectTypeFinder.findByCaps(this.objType), ['apiParam']);
    if (!(this.objType && this.objId && apiParam)) {
      this.setReportExecutions([]);
      return;
    }

    this.resolved = false;
    const params: any = {};
    params[apiParam] = this.objId;
    this.reportExecutionApi.listRelated(params).subscribe({
      next: (page) => {
        deferMarkForCheck(this.cdr, () => {
          this.setReportExecutions(page.results || []);
        });
      },
      error: () => {
        deferMarkForCheck(this.cdr, () => {
          this.setReportExecutions([]);
        });
      }
    });
  }
}
